import { call, put } from 'redux-saga/effects';
import { messagingActions } from 'messaging/redux/messagingActions';
import { ChannelViewedAction } from 'messaging/types/redux/messagingActions';
import { updateMessagingLastActivity } from '../../gql/messagigMutations';
import { getFirebaseToken } from './firebaseUtils';

export function* channelViewed(action: ChannelViewedAction): Generator {
    const channelId = action.payload;
    const firebaseToken = yield call(getFirebaseToken);

    if (firebaseToken) {
        yield put(
            messagingActions.updateMessagingLastActivity(updateMessagingLastActivity, channelId, String(firebaseToken)),
        );
    }
}
